
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./mp-common');
require('./mp');


// WEBPACK FOOTER //
// ./resources/assets/js/app.js